import { createSelector } from "reselect";

const roles = {};

/**
 * Return all roles.
 * @param {Object} state
 * @returns {Object[]} roles
 */
roles.get = state => state.roles.items;

/**
 * Returns uri of current role.
 * @param {Object} state
 * @returns {string} uri
 */
roles.getCurrentUri = state => state.roles.current;

/**
 * Returns filter term for roles.
 * @param {Object} state
 * @returns {string} filterTerm
 */
roles.getFilterTerm = state => state.roles.filterTerm;

/**
 * Returns current role object.
 * @param {Object} state
 * @returns {Object} role
 */
roles.getCurrent = createSelector(
  [roles.getCurrentUri, roles.get],
  (currentRoleUri, roles) => roles.find(role => role.$uri === currentRoleUri)
);

/**
 * Returns admin role object.
 * @param {Object} state
 * @returns {Object} role
 */
roles.getAdmin = createSelector(
  [roles.get],
  roles => roles.find(role => role.label === "admin")
);

/**
 * Returns roles filtered by roles.filterTerm.
 * @returns {Object[]} roles
 */
roles.getByFilterTerm = createSelector(
  [roles.get, roles.getFilterTerm],
  (roles, filter) => {
    if (filter) {
      return roles.filter(role => role.name.toLowerCase().includes(filter));
    }
    return roles;
  }
);

/**
 * Returns roles filtered by those applicable to RBAC global admins
 * @returns {Object[]} roles
 */
roles.getForRbacAdmin = createSelector(
  [roles.get],
  roles => {
    const rbacRoles = ["admin", "auditor", "operator", "user"];
    return roles.filter(role => rbacRoles.includes(role.label));
  }
);

export default roles;
